export enum PartListType {
    PartList = "PartList",
    QuickOrder = "QuickOrder",
    ShoppingCart = "ShoppingCart",
    SavedList = "SavedList",
    ActiveList = "ActiveList",
    Quote = "Quote",
}
